import React from 'react';

const InputField = ({ value, onChange, onBlur, editable, className, placeholder, onTab, inputRef }) => (
  <input
    type="text"
    value={value}
    onChange={(e) => onChange(e.target.value.replace(/[^0-9.]/g, ''))}
    onBlur={(e) => onBlur(e.target.value)}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === 'Tab') {
        e.preventDefault(); // Prevent default behavior
        onBlur(e.target.value); // Commit the change
        if (e.key === 'Tab' && onTab) {
          onTab(); // Move focus to the next input
        }
      }
    }}
    className={className}
    placeholder={placeholder}
    disabled={!editable}
    style={{ opacity: editable ? 1 : 0.5 }}
    ref={inputRef} // Attach ref for focus management
  />
);

export default InputField;